import {Component, OnInit, ViewChild} from '@angular/core';
import {ChatMessageService} from "../message.service";
import {ConferenceMessage, VideoConferenceService} from "../video-conference.service";
import {MessageChat} from "../model/MessageChat";
import {ModalDirective} from "ngx-bootstrap/modal";
import {MessageContact} from "../model/MessageContact";
declare let iNet: any;

@Component({
  selector: 'lib-video-chat-subscribe',
  templateUrl: './video-chat-subscribe.component.html',
  styleUrls: ['./video-chat-subscribe.component.css']
})
export class VideoChatSubscribeComponent implements OnInit {
  private messageObserver: any;
  messageChat: any;
  //userCalling = {sender: '', conferenceID: ''};
  avatarUrl!: string;
  audio: any;
  contacts: MessageContact[] = [];
  fullname: string = '';

  @ViewChild('childModal') childModal!: ModalDirective;

  constructor(private messageService: ChatMessageService,
              private videoConferenceService: VideoConferenceService) { }

  ngOnInit(): void {
    //console.log('[VideoChatSubscribeComponent]--ngOnInit--');
    this.eventMessageChat();
  }

  eventMessageChat() {
    this.messageObserver = this.messageService.messageReceived.subscribe((message: MessageChat) => {
      if (message.message.sender !== iNet.username) {
        if (message.message.message.alert) {
          let conferenceMessage= this.videoConferenceService.convertMessage(message.message.message.alert);
          if (conferenceMessage && conferenceMessage.conferenceID) {
            //this.messageChat = message;
            let envelopBody: any = message.message;
            this.avatarUrl = (envelopBody.message.end2end=='true') ? envelopBody.sender : envelopBody.message.alert;
            console.log('[conferenceMessage]--envelopBody--', envelopBody);
            this.onConferenceMessage(conferenceMessage, envelopBody.message.end2end, envelopBody.message.joins, envelopBody.sender);
            this.fullname = envelopBody.sender;
            this.findNameByCode(envelopBody.sender).then((name)=>{
              this.fullname =  name;
            })
          }
        }
      }
    });
  }

  joinVideo($event: any) {
    if ($event) {
      let conferenceID = $event['conferenceID'];
      const element: any = this.videoConferenceService.getVideoElement();
      if(element) {
        element.style.visibility = "visible";
        this.videoConferenceService.join(element, conferenceID, true, 350, (api: any) => {
          if (api) {
            api.addEventListener('readyToClose', () => {
              console.log('[readyToClose]');
              this.onClosed();
            });

            api.addEventListener('filmstripDisplayChanged', () => {
              console.log('[filmstripDisplayChanged]');
            });

            api.addEventListener('videoConferenceJoined', (data: any) => {
              console.log('[videoConferenceJoined]', data);
            });

            api.addEventListener('videoConferenceLeft', (data: any) => {
              console.log('[videoConferenceLeft]', data);
            });
          } else {
            // Todo: show message error
          }
        });
      }
    }
  }
  private onConferenceMessage(conference: ConferenceMessage, end2end: string, joins: string, sender: string) {
    let members = joins.split(',');
    if (members && members.length > 0 && conference) {
      if (conference.action == 'JOIN') {
        this.onActionJoin(Object.assign({}, conference.params), end2end, members, sender);
      } else if(conference.conferenceID) {
        if (conference.action === 'END') {
          this.onActionEnd(conference.conferenceID, end2end, members, sender, this.videoConferenceService.getVideoElement());
        } else {
          this.onActionLeft(conference.conferenceID, end2end, members, sender , this.videoConferenceService.getVideoElement());
        }
      }
    }
  }

  private onActionJoin(conference: Object, end2end: string, members: any[], sender: string) {
    if(this.messageChat) {
      return;
    }
    let creator = members[0];
    let showVideoConference = false;
    if (end2end == 'true') {
      if (members.length === 1) {
        showVideoConference = true;
      }
    } else if (end2end == 'false') {
      if(creator == sender){
        showVideoConference = true;
      }
    }
    if(showVideoConference){
      this.messageChat = conference;
      this.showCallingModal();
    }
  }

  private onActionEnd(conferenceID: string, end2end: string, members: any[], sender: string, query: any) {
    this.onActionLeft(conferenceID, end2end, members, sender, query);
  }

  private onActionLeft(conferenceID:string, end2end: string, members: any[], sender: string, query: any) {
    if(this.messageChat && conferenceID === this.messageChat.conferenceID){
      let hideVideoConference = false;
      let creator = members[0];
      if (end2end == 'true') {
        hideVideoConference = true;
      } else if (end2end == 'false') {
        if(creator == sender){
          hideVideoConference = true;
        }
      }
      if(hideVideoConference) {
        this.onClosed();
      }
    }
  }

  onDisposed(): void {
    this.videoConferenceService.dispose();
    this.messageChat = null;
  }

  private onClosed(): void {
    this.hideCallingModal();
    this.onDisposed();
    const element: any = this.videoConferenceService.getVideoElement();
    if(element) {
      element.style.visibility = "hidden";
    }
  }

  showCallingModal(): void {
    if(this.childModal) {
      this.childModal.show();
      this.playAudio();
    }
  }

  hideCallingModal(): void {
    if(this.childModal) {
      this.childModal.hide();
    }
    this.pauseAudio();
  }

  onAccessVideo() {
    this.hideCallingModal();
    this.joinVideo(this.messageChat);
  }

  onDisposeVideo() {
    this.hideCallingModal();
  }

  findNameByCode(usercode: string): Promise<string> {
    return new Promise(resolve => {
      if (this.contacts?.length > 0) {
        resolve(this.contacts.find((item: MessageContact) => {
          return item?.usercode === usercode;
        })?.fullname || usercode)
      } else {
        this.messageService.loadFriends().subscribe(
          (data: MessageContact[]) => {
            this.contacts = data;
            resolve(this.contacts.find((item: MessageContact) => {
              return item?.usercode === usercode;
            })?.fullname || usercode)
          }
        );
      }
    });
  }

  private playAudio() {
    if(!this.audio) {
      this.audio = new Audio();
      this.audio.src = "https://cdn.inetcloud.vn/data/products/unicorn/ring/ring.wav";
      this.audio.addEventListener('ended',() => {
        this.audio.currentTime = 0;
        this.audio.play();
      }, false);
      this.audio.load();
    }
    this.audio.play();
  }

  private pauseAudio() {
    if(this.audio) {
      this.audio.pause();
    }
  }

}
